import axios from 'axios';
import getHeaders from '../../constants/headers';
import { STORE_BASE_URL } from '../BaseURL';

export const deliveryOrder = (id, storeId, orderId, data) => {
  return axios({
    method: 'post',
    url:
      STORE_BASE_URL +
      '/store/api/secure/store/' +
      storeId +
      '/store-customer/' +
      id +
      '/order/' +
      orderId +
      '/delivery', // for android use
    headers: getHeaders(),
    data: JSON.stringify(data),
  });
};

export const OrderDeliveryVerificationRequest = (id, storeId, orderId, data) => {
  return axios({
    method: 'post',
    url:
      STORE_BASE_URL +
      '/store/api/secure/store/' +
      storeId +
      '/store-customer/' +
      id +
      '/order/' +
      orderId +
      '/order-delivery-verification-request', // for android use
    headers: getHeaders(),
    data: JSON.stringify(data),
  });
};

export const OrderDeliveryVerificationOTP = (
  id,
  storeId,
  orderId,
  data,
) => {
  return axios({
    method: 'post',
    url:
      STORE_BASE_URL +
      '/store/api/secure/store/' +
      storeId +
      '/store-customer/' +
      id +
      '/order/' +
      orderId +
      '/order-delivery-verification', // for android use
    headers: getHeaders(),
    data: JSON.stringify(data),
  });
};


export const refundOrder = (storeId, data) => {
  return axios({
    method: 'post',
    url:
      STORE_BASE_URL +
      '/store/api/secure/v1/refund/store/' +
      storeId +
      '/order-refund', // for android use
    headers: getHeaders(),
    data: JSON.stringify(data),
  });
};

